import { QuestionElem } from "./App"

export const initialData: QuestionElem[] = [ // Array di oggetti di tipo QuestionElem
  {
    title: 'Part 1. Multiple choice',
    type: 'intro',
    description: `
      You should spend about 15 minutes on this section.
      There are 20 questions. Choose the correct answer for each question.
    `,
    answers: [
      {
        text: 'Start',
      },
    ],
  },
  {
    question: `1. She's from Dublin. She <span class="answer-text">______</span> Irish.`,
    type: 'question',
    answers: [
      {
        text: 'is from',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: 'is',
        selected: false,
        isCorrect: true,
        points: 1
      },
      {
        text: 'isn\'t',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: 'are from',
        selected: false,
        isCorrect: false,
        points: 1
      }
    ],
  },
  {
    question: `2. <span class="answer-text">______</span> 's your first name?`,
    type: 'question',
    answers: [
      {
        text: 'Who',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: 'What',
        selected: false,
        isCorrect: true,
        points: 1
      },
      {
        text: 'How',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: 'Where',
        selected: false,
        isCorrect: false,
        points: 1
      }
    ],
  },
  {
    question: `3. Peter's <span class="answer-text">______</span> name is Michael.`,
    type: 'question',
    answers: [
      {
        text: 'brother\'s',
        selected: false,
        isCorrect: true,
        points: 1
      },
      {
        text: 'sister is',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: 'brother',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: 'sisters',
        selected: false,
        isCorrect: false,
        points: 1
      },
    ]
  },
  {
    question: '4. She <span class="answer-text">______</span> jeans to work.',
    type: 'question',
    answers: [
      {
        text: 'wears usually',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: 'is usually wearing',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: 'usually wears',
        selected: false,
        isCorrect: true,
        points: 1
      },
      {
        text: 'is wearing usually',
        selected: false,
        isCorrect: false,
        points: 1
      }
    ]
  },
  {
    question: '5. You <span class="answer-text">______</span> to walk, you can take a bus.',
    type: 'question',
    answers: [
      {
        text: 'mustn\'t',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: 'have',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: 'must',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: 'don\'t have',
        selected: false,
        isCorrect: true,
        points: 1
      }
    ]
  },
  {
    question: '6. <span class="answer-text">______</span> does that jacket cost?',
    type: 'question',
    answers: [
      {
        text: 'how often',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: 'how long',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: 'how many',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: 'how much',
        selected: false,
        isCorrect: true,
        points: 1
      }
    ]
  },
  {
    question: '7. They <span class="answer-text">______</span> fly to India.',
    type: 'question',
    answers: [
      {
        text: 'didn\'t',
        selected: false,
        isCorrect: true,
        points: 1
      },
      {
        text: 'doesn\'t',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: 'haven\'t',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: 'has',
        selected: false,
        isCorrect: false,
        points: 1
      }
    ]
  },
  {
    question: '8. <span class="answer-text">______</span> you like a coffee?',
    type: 'question',
    answers: [
      {
        text: 'will',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: 'Would',
        selected: false,
        isCorrect: true,
        points: 1
      },
      {
        text: 'Did',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: 'Do',
        selected: false,
        isCorrect: false,
        points: 1
      }
    ]
  },
  {
    question: '9. I <span class="answer-text">______</span> to go home now.',
    type: 'question',
    answers: [
      {
        text: '\'m wanting',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: 'will want',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: 'want',
        selected: false,
        isCorrect: true,
        points: 1
      },
      {
        text: 'wanting',
        selected: false,
        isCorrect: false,
        points: 1
      }
    ]
  },
  {
    question: '10. What <span class="answer-text">______</span> tonight?',
    type: 'question',
    answers: [
      {
        text: 'they do',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: 'do they do',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: 'are they doing',
        selected: false,
        isCorrect: true,
        points: 1
      },
      {
        text: 'are they do',
        selected: false,
        isCorrect: false,
        points: 1
      }
    ]
  },
  {
    question: '11. When <span class="answer-text">______</span> arrive?',
    type: 'question',
    answers: [
      {
        text: 'they did',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: 'did they',
        selected: false,
        isCorrect: true,
        points: 1
      },
      {
        text: 'have they',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: 'does they',
        selected: false,
        isCorrect: false,
        points: 1
      }
    ]
  },
  {
    question: '12. She realised she <span class="answer-text">______</span> to take her phone so she went home to get it.',
    type: 'question',
    answers: [
      {
        text: '\'ve forgot',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: '\'d forgot',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: '\'d forgotten',
        selected: false,
        isCorrect: true,
        points: 1
      },
      {
        text: 'were forgot',
        selected: false,
        isCorrect: false,
        points: 1
      }
    ]
  },
  {
    question: '13. He\'s French but he <span class="answer-text">______</span> in London at the moment.',
    type: 'question',
    answers: [
      {
        text: 'living',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: 'does live',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: '\'s living',
        selected: false,
        isCorrect: true,
        points: 1
      },
      {
        text: 'lived',
        selected: false,
        isCorrect: false,
        points: 1
      }
    ]
  },
  {
    question: '14. What <span class="answer-text">______</span> of doing now?',
    type: 'question',
    answers: [
      {
        text: 'are you think',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: 'do you think',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: 'think you',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: 'are you thinking',
        selected: false,
        isCorrect: true,
        points: 1
      }
    ]
  },
  {
    question: '15. We <span class="answer-text">______</span>  on holiday tomorrow so I hope the weather stays warm.',
    type: 'question',
    answers: [
      {
        text: '\'ve gone',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: '\'ll going',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: '\'re going',
        selected: false,
        isCorrect: true,
        points: 1
      },
      {
        text: 'will to go',
        selected: false,
        isCorrect: false,
        points: 1
      }
    ]
  },
  {
    question: '16. What <span class="answer-text">______</span>  at the end of the film? I missed it.',
    type: 'question',
    answers: [
      {
        text: 'did happen',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: 'happened',
        selected: false,
        isCorrect: true,
        points: 1
      },
      {
        text: '\'s happened',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: 'was happened',
        selected: false,
        isCorrect: false,
        points: 1
      }
    ]
  },
  {
    question: '17. Do you mind me asking how old <span class="answer-text">______</span> ?',
    type: 'question',
    answers: [
      {
        text: 'are you',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: 'you\'re',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: 'you are',
        selected: false,
        isCorrect: true,
        points: 1
      },
      {
        text: 'you have',
        selected: false,
        isCorrect: false,
        points: 1
      }
    ]
  },
  {
    question: '18. I <span class="answer-text">______</span> for my keys for half an hour and I still haven\'t found them!',
    type: 'question',
    answers: [
      {
        text: '\'ve been looked',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: '\'ve been looking',
        selected: false,
        isCorrect: true,
        points: 1
      },
      {
        text: 'looked',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: '\'m looking',
        selected: false,
        isCorrect: false,
        points: 1
      }
    ]
  },
  {
    question: '19. They <span class="answer-text">______</span> in a large house for twenty years before moving to a bungalow.',
    type: 'question',
    answers: [
      {
        text: '\'ve lived',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: 'lived',
        selected: false,
        isCorrect: true,
        points: 1
      },
      {
        text: 'already live',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: 'recently lived',
        selected: false,
        isCorrect: false,
        points: 1
      }
    ]
  },
  {
    question: '20. This time tomorrow, they <span class="answer-text">______</span> in San Francisco. How exciting!',
    type: 'question',
    answers: [
      {
        text: '\'ll land',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: '\'ll be landed',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: '\'ll be landing',
        selected: false,
        isCorrect: true,
        points: 1
      },
      {
        text: 'have landed',
        selected: false,
        isCorrect: false,
        points: 1
      }
    ]
  },
  {
    title: 'Part 2. Listening',
    type: 'intro',
    special: 'listening',
    description: `
      (EN)
      There are 6 questions. For each question, choose the correct answer. You should attempt to answer the questions while you listen.
      When you are ready to start, click play on the audio player below. <br>

      (IT)
      Ci sono 6 domande. Per ogni domanda, scegliete la risposta corretta. Si deve cercare di rispondere alle domande mentre si ascolta.
      Quando siete pronti per iniziare, cliccate su play sul lettore audio qui sotto.
    `,
    answers: [
      {
        text: 'Start',
      },
    ]
  },
  {
    question: '1. What does Tim enjoy most about his job?',
    type: 'question',
    answers: [
      {
        text: 'Sorting out all the details.',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: 'Getting to know the musicians.',
        selected: false,
        isCorrect: true,
        points: 1
      },
      {
        text: 'Listening to lots of good music.',
        selected: false,
        isCorrect: false,
        points: 1
      }
    ]
  },
  {
    question: '2. Young musicians who want to do the course ',
    type: 'question',
    answers: [
      {
        text: 'need to fill in an online form.',
        selected: false,
        isCorrect: true,
        points: 1
      },
      {
        text: 'have to perform to a very high level.',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: 'must be able to speak English very well.',
        selected: false,
        isCorrect: false,
        points: 1
      }
    ]
  },
  {
    question: '3. Tim says that the teachers on the course',
    type: 'question',
    answers: [
      {
        text: 'usually enjoy themselves.',
        selected: false,
        isCorrect: true,
        points: 1
      },
      {
        text: 'are always complaining.',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: 'are extremely well-paid.',
        selected: false,
        isCorrect: false,
        points: 1
      }
    ]
  },
  {
    question: '4. Tim likes to hold the course in a place which',
    type: 'question',
    answers: [
      {
        text: 'is specially designed for musicians.',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: 'is convenient for public transport.',
        selected: false,
        isCorrect: true,
        points: 1
      },
      {
        text: 'is a long way from a big city.',
        selected: false,
        isCorrect: false,
        points: 1
      }
    ]
  },
  {
    question: '5. What does Tim say about musical instruments?',
    type: 'question',
    answers: [
      {
        text: 'Students cannot bring expensive ones.',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: 'Students sometimes lose them.',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: 'Students keep them in a special place.',
        selected: false,
        isCorrect: true,
        points: 1
      }
    ]
  },
  {
    question: '6. What does Tim say about the concert tour after the course?',
    type: 'question',
    answers: [
      {
        text: 'It has to make a lot of money.',
        selected: false,
        isCorrect: false,
        points: 1
      },
      {
        text: 'It needs to be carefully planned.',
        selected: false,
        isCorrect: true,
        points: 1
      },
      {
        text: 'It\'s difficult to sell tickets.',
        selected: false,
        isCorrect: false,
        points: 1
      }
    ]
  },
  {
    title: 'Part 3. Writing',
    type: 'intro',
    description: `
      You should spend about 15 minutes on this section.
      You see this post on an English language website. Write your answer in 100 - 150 words.
    `,
    answers: [
      {
        text: 'Start',
      },
    ]
  },
  {
    question: `
      What kind of films do you enjoy?
      Do you prefer watching them at the cinema or at home? Why?

      Write an article answering these questions and we will post it on our website!
    `,
    type: 'question',
    special: 'writing',
    content: '',
    answers: [
      {
        text: 'Concludi'
      }
    ]
  },
];

